"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var MultiLayout = /*#__PURE__*/function () {
  /**
   * layout class that just keeps a number of named sub-layouts.
   * basically just a fancier
   * `{ layout1: new GranularRectLayout(), layout2: new GranularRectLayout() ...}`
   */
  function MultiLayout(SubLayoutClass) {
    var subLayoutConstructorArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, MultiLayout);
    this.SubLayoutClass = SubLayoutClass;
    this.subLayoutConstructorArgs = subLayoutConstructorArgs;
    this.subLayouts = new Map();
  }
  _createClass(MultiLayout, [{
    key: "getDataByID",
    value: function getDataByID(id) {
      var _iterator = _createForOfIteratorHelper(this.subLayouts.values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var layout = _step.value;
          // @ts-ignore
          var r = layout.getDataByID(id);
          if (r) {
            return r;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return undefined;
    }
  }, {
    key: "getSublayout",
    value: function getSublayout(layoutName) {
      var subLayout = this.subLayouts.get(layoutName);
      if (subLayout === undefined) {
        subLayout = new this.SubLayoutClass(this.subLayoutConstructorArgs);
        this.subLayouts.set(layoutName, subLayout);
        return subLayout;
      }
      return subLayout;
    }
  }, {
    key: "addRect",
    value: function addRect(layoutName, id, left, right, height) {
      var data = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      return this.getSublayout(layoutName).addRect(id, left, right, height, data);
    }
  }, {
    key: "discardRange",
    value: function discardRange(layoutName, left, right) {
      var _a;
      return (_a = this.subLayouts.get(layoutName)) === null || _a === void 0 ? void 0 : _a.discardRange(left, right);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = {};
      var _iterator2 = _createForOfIteratorHelper(this.subLayouts.entries()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            layoutName = _step2$value[0],
            sublayout = _step2$value[1];
          data[layoutName] = sublayout.toJSON();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return data;
    }
  }]);
  return MultiLayout;
}();
exports.default = MultiLayout;